import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-save-confirmation-dialog',
  standalone: true,
  imports: [MatButtonModule,MatDialogModule],
  templateUrl: './save-confirmation-dialog.component.html',
  styleUrl: './save-confirmation-dialog.component.scss'
})
export class SaveConfirmationDialogComponent {
  constructor(private dialogRef: MatDialogRef<SaveConfirmationDialogComponent>) {}

  onSaveExit() {
    this.dialogRef.close('save'); 
  }

  onExit() {
    this.dialogRef.close('exit'); 
  }

  onCancel() {
    this.dialogRef.close('cancel');
    
  }
}
